import React from 'react';

const DetailPageParagraph = ({ children }) => {
  return (
    <p style={{ marginTop: '3rem', marginBottom: '3rem' }}>
      {children}
    </p>
  );
};

export default DetailPageParagraph; 